import * as type from "../actions/types";

const initialState = {
  showManageListsModal: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.SHOW_MANAGE_LISTS_MODAL:
      return {
        ...state,
        showManageListsModal: true,
      };
    case type.HIDE_MANAGE_LISTS_MODAL:
      return {
        ...state,
        showManageListsModal: false,
      };
    default:
      return state;
  }
};
